import styled from 'styled-components'

const WindowTitle = styled.div`
  border-radius: 3px 3px 0 0;

  position: fixed;
  width: 100%;
  padding: 0.5rem;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.gray2};
`

export default WindowTitle
